import { UserNotificationPreferences } from '../../notifications/notification.settings';
import { RoomKey } from '../socket.room.key';

export interface NotificationSettingsPayload<T> {
    type: 'updated';
    payload: T;
}

export const NotificationSettingsRooms = {
    userNotificationSettings: (userId: string): RoomKey<NotificationSettingsPayload<UserNotificationPreferences>> => ({ key: `settings:notifications:user:${userId}` }),
};
